// extracted by mini-css-extract-plugin
export default {"centeringDiv":"GuideImages_centeringDiv__EywnX","textSmaller":"GuideImages_textSmaller__Eopqp"};